import type { Apartment } from '../types/apartment';

/** Fields NeonResultCard / the map actually read. Everything else (reviews,
 *  amenities, full floorplan details, AI prose) is dead weight in localStorage. */
const CARD_FIELDS = [
  'id', 'name', 'neighborhood', 'region', 'city', 'address',
  'starting_price', 'starting_prices', 'starting_prices_display', 'starting_price_numeric',
  'pricing_source', 'pricing_updated_at', 'price_ranges', 'userSelectedBedrooms',
  'bedrooms', 'rating', 'google_rating', 'review_count',
  'walk_score', 'transit_score', 'bike_score',
  'latitude', 'longitude', 'is_taco_favorite', 'year_built',
  'match_score', 'why_chosen', 'pet_friendly',
] as const;

export function trimApartment(a: Apartment): Apartment {
  const out: Record<string, unknown> = {};
  const src = a as unknown as Record<string, unknown>;
  for (const k of CARD_FIELDS) {
    if (src[k] !== undefined) out[k] = src[k];
  }
  // Pricing normalizers choose per-bed minima across these sources. Keep
  // only their price/inventory fields, not images or descriptive payloads.
  for (const key of ['floorplans', 'firedev_floorplans']) {
    if (Array.isArray(src[key])) {
      out[key] = (src[key] as unknown[]).filter((plan): plan is Record<string, unknown> =>
        !!plan && typeof plan === 'object').map(plan => ({
          bedrooms: plan.bedrooms, category: plan.category, starting_price: plan.starting_price,
        }));
    }
  }
  // Keep just enough photos for the card carousel.
  if (Array.isArray(src.local_photos)) out.local_photos = (src.local_photos as unknown[]).slice(0, 3);
  if (Array.isArray(src.photos)) out.photos = (src.photos as unknown[]).slice(0, 3);
  return out as unknown as Apartment;
}

